import React, { useState } from "react";
// import { AutoComplete } from './kendo.all.d.ts';
import { AutoComplete } from "@progress/kendo-react-dropdowns";
//import { ISearchParameters } from "./ISearchParameters";
import data from "./data.json";
import Fuse from "fuse.js";
import RecommenderChat from "./recommenderChat";
import Item from "./item";
import { buildMessageTree, bot, user } from "./allMessages";

const SettingsPage = () => {
  const [searchData, setSearchData] = useState(data);
  const [searchParameters, setSearchParameters] = useState({}); // <ISearchParameters>

  const searchItem = (query) => {
    if (!query) {
      setSearchData(data);
      return;
    }

    const fuse = new Fuse(data, { keys: ["name", "tags"] });
    const result = fuse.search(query);
    const finalResult = [];

    if (result.length) {
      result.forEach((item) => {
        finalResult.push(item.item);
      });
      setSearchData(finalResult);
    } else {
      setSearchData([]);
    }
  };

  const filterListByChatResult = (messageIndex, filter) => { // ISearchParameters
    console.log(messageIndex, filter);

    setSearchParameters(filter);

    if (!(filter?.filter)) {
      setSearchData(data);
      return;
    }

    const fuse = new Fuse(data, { keys: [filter.filter.field] });
    const result = fuse.search(filter.filter.value);
    //const result = [];
    const finalResult = [];

    if (result.length) {
      result.forEach((item) => {
        finalResult.push(item.item);
      });
      setSearchData(finalResult);
    } else {
      setSearchData([]);
    }
  };

  const allMessages = buildMessageTree(data);
  return (
    <div>
      <p className="title"> GEMKER </p>
      <div className="search-container">
        <RecommenderChat onSearchItem={filterListByChatResult} allMessages={allMessages} />
        <br />
        <AutoComplete
          placeholder="szabad szavas keresés"
          data={data}
          textField="name"
          defaultValue=""
          onChange={(e) => searchItem(e.target.value)}
        />
      </div>

      <div className="item-container">
        {searchData.map((item) => (
          <Item {...item} key={item.name} />
        ))}
      </div>
    </div>
  );
};

export default SettingsPage;
